import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import MaterialIcon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Styled from '../../lab/Styled';
import ColoredIcon from './ColoredIcon';
import ICON_TYPES, { getRepositoryIcon } from './IconTypes';
import getDataProps from '../../utils/propsUtil';
import cx from 'classnames';
export var LABEL_PLACEMENTS = {
  start: true,
  end: true
};
export var TOOLTIP_PLACEMENTS = {
  top: true,
  bottom: true,
  left: true,
  right: true,
  'top-end': true,
  'bottom-start': true
};
/** @param {import('./types').IconProps} props*/

var getIcon = function getIcon(props) {
  var icon = ICON_TYPES['default'];
  if (props.type && ICON_TYPES[props.type]) icon = ICON_TYPES[props.type];
  if (typeof props.path !== 'undefined') icon = getRepositoryIcon(props.path);
  return icon;
};
/**
 *
 * @param {string} icon
 * @param {import('./types').IconProps} props
 * @param {object} classes
 */


var getClassName = function getClassName(icon, props, classes) {
  var className = icon;

  if (typeof props.pressed !== 'undefined') {
    if (props.pressed) className += ' ' + classes.pressed;else className += ' ' + classes.raised;
  }

  if (!props.onClick) {
    if (typeof props.hoverable !== 'undefined') if (props.hoverable) className += ' ' + classes.hoverable;
  }

  if (props.className) className += ' ' + props.className;
  return className;
};
/**
 * A versatile icon that makes sure icons are consistent throughout the app
 * @param {import('./types').IconProps} props
 */


function Icon(props) {
  var icon = getIcon(props);
  var styles = {};

  var _props$buttonProps = props.buttonProps,
      buttonClassName = _props$buttonProps.className,
      buttonProps = _objectWithoutProperties(_props$buttonProps, ["className"]);

  var btnClassName = cx(buttonClassName);
  var btnStyles = {};

  if (props.style) {
    var newStyles = _objectSpread({}, styles, props.style);

    if (props.onClick) btnStyles = newStyles;else styles = newStyles;
  }

  if (btnStyles.fontSize) styles.fontSize = btnStyles.fontSize;
  return React.createElement(Styled, {
    styles: styleSheet,
    theme: true,
    name: "ECIcon"
  }, function (classes, theme) {
    var iconProps = {
      className: classes.icon + ' ' + getClassName(icon, props, classes),
      style: styles
    };
    var isFontAwesome = props.className && props.className.indexOf('fa-') > -1;
    var FontIcon = null;
    if (props.type || props.path || isFontAwesome) FontIcon = React.createElement(MaterialIcon, Object.assign({
      color: props.color
    }, iconProps));

    if (typeof props.underlineColor !== 'undefined') {
      FontIcon = React.createElement(ColoredIcon, {
        color: props.underlineColor,
        iconColor: props.color
      }, FontIcon);
    }

    var isTextButton = false;

    if (props.label && props.labelPlacement) {
      var labelProps = {
        style: {
          marginTop: 0,
          marginBottom: 0,
          marginLeft: props.labelPlacement === 'end' ? theme.spacing(0.5) : 0,
          marginRight: props.labelPlacement === 'start' || props.endAdornment ? theme.spacing(0.5) : 0,
          lineHeight: 'inherit'
        },
        component: 'span',
        color: 'inherit',
        variant: props.labelVariant
      };
      if (!props.labelVariant) labelProps.style.fontSize = '0.875rem';
      if (props.style && props.style.color) labelProps.style.color = props.style.color;
      var text = React.createElement(Typography, labelProps, props.label);
      FontIcon = React.createElement(React.Fragment, null, props.labelPlacement === 'start' && text, FontIcon, props.labelPlacement === 'end' && text);
      if (props.onClick) isTextButton = true;
    }

    if (props.onClick) {
      btnClassName = cx(btnClassName, classes.button);
      var ButtonComponent = isTextButton ? Button : IconButton;
      var textBtnProps = {};

      if (isTextButton) {
        textBtnProps.size = 'small';
        btnClassName = cx(btnClassName, 'text-button');
      } else {
        if (props.buttonSize === 'small') btnClassName = cx(btnClassName, classes.buttonSmall);else if (props.buttonSize === 'medium') btnClassName = cx(btnClassName, classes.buttonMedium);
        btnClassName = cx(btnClassName, 'icon-button');
      }

      if (props.hoverable) {
        if (props.hoverable === true) btnClassName = cx(btnClassName, classes.hoverable);else if (props.hoverable === 'background') btnClassName = cx(btnClassName, classes.hoverableBackground);else if (props.hoverable === 'opacity') btnClassName = cx(btnClassName, classes.hoverableOpacity);
      }

      if (!buttonProps.color || buttonProps.color === 'inherit') btnClassName = cx(btnClassName, classes.buttonInherit);
      FontIcon = React.createElement(ButtonComponent, Object.assign({}, textBtnProps, {
        style: btnStyles,
        className: btnClassName,
        onClick: props.onClick,
        "aria-label": props['aria-label'] || props.label,
        disabled: props.disabled
      }, getDataProps(props), buttonProps), FontIcon, props.endAdornment && React.createElement(Icon, {
        type: props.endAdornment,
        style: {
          fontSize: '.7rem'
        }
      }));
    }

    if (!props.disabled && props.label && !props.labelPlacement) {
      FontIcon = React.createElement(Tooltip, {
        title: props.label,
        disableFocusListener: !props.onClick,
        placement: props.tooltipPlacement || 'bottom',
        PopperProps: {
          style: {
            pointerEvents: 'none'
          }
        }
      }, FontIcon);
    }

    return FontIcon;
  });
}

var styleSheet = function styleSheet(theme) {
  return {
    icon: {
      lineHeight: '1em',
      '.text-button &': {
        fontSize: '1rem'
      }
    },
    button: {
      '& .MuiButton-label': {
        textTransform: 'none'
      }
    },
    buttonInherit: {
      color: 'inherit'
    },
    buttonSmall: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      padding: 0
    },
    buttonMedium: {
      width: theme.spacing(4.5),
      height: theme.spacing(4.5),
      padding: 0
    },
    hoverable: {
      opacity: 0.85,
      '&:hover': {
        opacity: 1,
        backgroundColor: '#00000010'
      }
    },
    hoverableOpacity: {
      opacity: 0.85,
      '&:hover': {
        opacity: 1
      }
    },
    hoverableBackground: {
      '&:hover': {
        backgroundColor: '#00000010'
      }
    },
    contained: {
      opacity: 0.4
    },
    pressed: {
      opacity: 1
    }
  };
};

Icon.displayName = 'Icon';
Icon.defaultProps = {
  color: 'inherit',
  label: '',
  disabled: false,
  'data-testid': 'icon',
  buttonSize: 'large',
  buttonProps: {}
};
export default Icon;